import { action } from 'mobx'

import AgencyEventFee from 'Models/AgencyEventFee'
import AgencyResources from 'Services/AgencyResources'
import BaseStore from 'Stores/base_store/BaseStore'
import { getStoreFor } from 'Stores/StoreInstances'

export const STORE_TYPE = 'AgencyEventFees'

export function getAgencyEventFeesStoreFor (param, opts = {}) {
  return getStoreFor(AgencyEventFeesStore, STORE_TYPE, param, {
    forceUnique: false,
    preload: opts.preload,
    autoFetch: opts.autoFetch,
    fetchAll: opts.fetchAll,
  })
}

class AgencyEventFeesStore extends BaseStore {
  constructor (seedData) {
    const opts = {
      paginate: false,
    }
    super(STORE_TYPE, seedData, opts)
  }

  @action
  _fetchAll () {
    let payload = {
      ...this._filter,
    }
    return AgencyResources.requestResources(payload)
      .then(resources => resources.agency_event_fees.map(newAgencyEventFee))
      .catch(console.error)
  }
}

function newAgencyEventFee (data) {
  return new AgencyEventFee(data)
}

export default AgencyEventFeesStore
